import { useEffect, useRef } from 'react';
import type { ThreeCtx } from './useThreeScene';
import { applyLightPreset, createLightRig, type LightRig } from '../lib/light-rigs';
import type { LightPreset } from '../types';

export function useLighting(ctx: ThreeCtx | null, preset: LightPreset, exposure: number) {
  const rigRef = useRef<LightRig | null>(null);

  useEffect(() => {
    if (!ctx) return;
    const rig = createLightRig();
    ctx.scene.add(rig.group);
    rigRef.current = rig;
    applyLightPreset(ctx.renderer, ctx.scene, rig, preset);
    return () => {
      ctx.scene.remove(rig.group);
      rigRef.current = null;
    };
  }, [ctx, preset]);

  useEffect(() => {
    if (ctx && rigRef.current) applyLightPreset(ctx.renderer, ctx.scene, rigRef.current, preset);
  }, [ctx, preset]);

  // additional exposure multiplier from UI (1:1 with old optional override behavior)
  useEffect(() => {
    if (!ctx) return;
    // re-apply preset to get base exposure, then multiply
    if (rigRef.current) {
      applyLightPreset(ctx.renderer, ctx.scene, rigRef.current, preset);
      ctx.renderer.toneMappingExposure = ctx.renderer.toneMappingExposure * exposure;
    }
  }, [ctx, exposure, preset]);
}
